module.exports = __webpack_public_path__ + "img/action6.2b70490b.jpg";